module.exports = __webpack_public_path__ + "static/media/ca_3.5a9d20d7.png";